import { render, staticRenderFns } from "./DashboardInvoices.vue?vue&type=template&id=c1c29638&"
import script from "./DashboardInvoices.vue?vue&type=script&lang=js&"
export * from "./DashboardInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports